import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { articles } from "@/data/articles";

const featuredSlugs = ["directory-is-lying", "geography-not-billing-code", "776-physician-gap"];

export function FeaturedResearchSection() {
  const featured = featuredSlugs
    .map((s) => articles.find((a) => a.slug === s))
    .filter((a): a is NonNullable<typeof a> => Boolean(a));

  return (
    <section aria-labelledby="featured-research" className="bg-ivory text-ivory-foreground py-16 sm:py-20">
      <div className="max-w-6xl mx-auto px-5 lg:px-8">
        <div className="flex flex-wrap items-end justify-between gap-4 mb-10">
          <div>
            <p className="font-mono text-xs uppercase tracking-[0.2em] text-ivory-gold font-semibold">
              Featured research
            </p>
            <h2 id="featured-research" className="mt-3 font-display text-3xl sm:text-4xl font-bold">
              Start with the record
            </h2>
          </div>
          <Link
            to="/articles"
            className="inline-flex items-center gap-2 text-sm font-semibold text-ivory-gold underline-offset-4 hover:underline"
          >
            All research <ArrowRight className="h-4 w-4" aria-hidden="true" />
          </Link>
        </div>

        <ul className="grid gap-6 md:grid-cols-3">
          {featured.map((a) => (
            <li key={a.slug}>
              <Link
                to={a.path}
                className="group flex h-full flex-col rounded-lg border border-ivory-foreground/15 bg-ivory p-6 transition-colors hover:border-ivory-gold focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ivory-gold"
              >
                <span className="text-xs uppercase tracking-[0.16em] text-ivory-gold font-semibold mb-3">
                  {a.category}
                </span>
                <h3 className="font-display text-xl font-bold leading-snug mb-3 group-hover:underline underline-offset-4">
                  {a.title}
                </h3>
                <p className="text-[15px] leading-relaxed text-ivory-muted mb-5 flex-1">{a.description}</p>
                <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-ivory-gold">
                  Read <ArrowRight className="h-4 w-4" aria-hidden="true" />
                </span>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
